<template>
  <div class="max-w-7xl mx-auto sm:px-2 lg:px-8">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "CenteredContainer"
};
</script>

<style scoped></style>
